<!--
Wrapper component to handle hiding/displaying other HTML components
Prop toggle: a string from feature-flags.js enums, matching the keys of toggle-logic.js
-->
<template>
    <span v-if="toggleDisplay(toggle) && hasSlot('default')" :class="slotClass">
        <slot />
    </span>
    <span v-else-if="!toggleDisplay(toggle) && hasSlot('alternative')" :class="slotClass">
        <slot name="alternative" />
    </span>
</template>

<script setup>
import { Comment, useSlots } from 'vue';
import { useStore } from 'vuex';
import { isNil } from 'lodash';
import featureFlagEnums from '@enums/feature-flags';

defineProps({
    // key of the toggle feature in toggleLogic
    toggle: String,
    slotClass: String,
});

const store = useStore();
const slots = useSlots();

const hasSlot = slotName => {
    const vnodes = slots[slotName]?.();
    return vnodes?.some(vnode => vnode.type !== Comment) ?? false;
};

const toggleDisplay = toggle => {
    // ensure we are passing a valid toggle
    console.assert(
        featureFlagEnums[toggle],
        `Specified toggle '${toggle}' has not been defined as an enum`
    );
    const decision = store.state.clientConfig.toggleLogic[toggle];
    console.assert(
        !isNil(decision),
        `Specified toggle '${toggle}' does not have a corresponding entry in toggle-logic.js`
    );

    /**
     * return the (boolean cast) value of a feature decision.
     */
    return !!decision;
};
</script>
